const LIGHT = 'light'; // Modalità usata dal libro "Performer B1 Phases / Volume ONE" su laZ Esercizi
const DEFAULT = 'default';
const EMBEDDED = 'embedded'; // Modalità usata nelle "tasche" anteprima su laZ Esercizi

export const APPLICATION_MODE = {
    LIGHT,
    DEFAULT,
    EMBEDDED,
};
